import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format, formatISO } from "date-fns";

const PreparatoryTraining: FC = () => {
    return (
      <Box mt={1}>
        <Header>
            <Box display={'flex'}>
                <Typography mb={1} ml={20}>Специальность(профессия)</Typography>
                <Typography mb={1} ml={34}>Дата начала</Typography>
                <Typography mb={1} ml={14} mr={1}>Дата окончания</Typography>
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
        </Header>
        <Body>
            <Box display="flex" alignItems="center" mt={1} mb={1}>
                <Typography mr={1} ml={1}>Дата подготовки</Typography>
                <Typography mr={1}>c</Typography>
                <TextField
                value={format(1683886255004, "dd.MM.yyyy")}
                variant="outlined"
                size="small"
                sx={{ width: "200px", mr: 1 }} 
                />
                <Typography mr={1}>по</Typography>
                <TextField
                value={format(1683886255004, "dd.MM.yyyy")}
                variant="outlined"
                size="small"
                sx={{ width: "201px", mr: 1}} 
                />
            </Box>
            <TextField 
                label="Специальность(профессия)"
                variant="outlined"
                size="small"
                sx={{ width: "600px", mb: 1 }}
            />
            <TextField 
                label="Вид подготовки"
                variant="outlined"
                size="small"
                sx={{ width: "600px", mb: 1 }}
            />
            <TextField 
                label="Место обучения"
                variant="outlined"
                size="small"
                sx={{ width: "600px", mb: 1 }}
            />
            <TextField 
                label="Вид документа"
                variant="outlined"
                size="small"
                sx={{ width: "400px", mb: 1 }}
            />
            <TextField 
                label="Номер диплома(свидетельства)"
                variant="outlined"
                size="small"
                sx={{ width: "300px", mb: 1 }}
            />
            <TextField
                label='Дата выдачи документа'
                value={format(1683886255004, "dd.MM.yyyy")}
                variant="outlined"
                size="small"
                sx={{ width: "300px", mr: 1}} 
            />
        </Body>
      </Box>
    );
  };

export default PreparatoryTraining;

